const actionTypes = {
  SET_DISCOUNT_CODE_COLLECTION: "SET_DISCOUNT_CODE_COLLECTION",
  CLEAR_DISCOUNT_CODE_COLLECTION: "CLEAR_DISCOUNT_CODE_COLLECTION",
};

export default actionTypes;
